module.exports = __webpack_public_path__ + "static/media/Robert_LaMagaReiter.9a1a8a42.jpg";